import React from 'react';
import PropTypes from 'prop-types';
import style from './index.css';
import ColumnIntro from '../../../components/columnIntro';
import { NewsStream } from '@ifeng/news-stream';
import '@ifeng/news-stream/lib/NewsStream/style/news-stream-global.css';
import ShanklistComponents from '../../originalComponents/index';
import Chip from 'Chip';

const getType = function getType(type) {
    const types = {
        recommendFragment: 'recommend',
        staticFragment: 'static',
        structuredFragment: 'struct',
    };

    return types[type] ? types[type] : type;
};

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    // 渲染
    componentsView(mainData) {
        const { noAd } = this.props.content;

        return mainData.map((item, index) => {
            const { chip, data, component, componentOptions } = item;

            if (!(component in ShanklistComponents)) return null;

            if (chip.user && chip.user !== '') {
                // 重写编辑碎片的配置
                if (componentOptions.key) chip.id = componentOptions.key;
                if (componentOptions.type) chip.type = getType(componentOptions.type);

                return (
                    <Chip key={index} content={data} {...chip}>
                        {React.createElement(ShanklistComponents[component], { componentOptions, noAd })}
                    </Chip>
                );
            } else {
                return React.createElement(ShanklistComponents[component], {
                    key: index,
                    componentOptions,
                    content: data,
                    noAd,
                });
            }
        });
    }

    render() {
        const { content } = this.props;
        const { columnIntroData, newsstream, columnId, isEnd, mainData } = content;

        /**
         * 组件分发数据
         */

        return (
            <div className={style.wrap_1000w}>
                <div className={style.left_640w}>
                    {/* mainData */}
                    {/* 原创列表页：信息流推荐位 */}
                    {this.componentsView(mainData)}
                    <NewsStream content={newsstream} columnId={columnId} isEnd={isEnd} />
                </div>
                <div className={style.right_300w}>
                    <ColumnIntro content={columnIntroData} />
                </div>
            </div>
        );
    }
}

export default Content;
